import { getPasswordPolicyError } from '../utils/passwordPolicy';

const checked = (value, options) => {
  if (value !== true) {
    return options.message || 'must be checked';
  }
};

const passwordPolicy = (value) => {
  const key = getPasswordPolicyError(value);
  if (key) {
    return `^${key}`;
  }
};

export default {
  checked,
  passwordPolicy,
};
